/* PEAK GEAR — theme.js */
(function () {
  "use strict";

  var moneyFormat = window.PEAK && window.PEAK.moneyFormat ? window.PEAK.moneyFormat : "${{amount}}";

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (amount.endsWith(".00")) amount = amount.slice(0, -3);
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in-view"); });
  }

  /* ---------- Mobile nav drawer ---------- */
  var navDrawer = document.getElementById("NavDrawer");
  document.querySelectorAll("[data-nav-open]").forEach(function (btn) {
    btn.addEventListener("click", function () { navDrawer && navDrawer.classList.add("is-open"); });
  });
  document.querySelectorAll("[data-nav-close]").forEach(function (el) {
    el.addEventListener("click", function () { navDrawer && navDrawer.classList.remove("is-open"); });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById("CartDrawer");
  var cartItemsEl = cartDrawer ? cartDrawer.querySelector("[data-cart-items]") : null;
  var cartSubtotalEl = cartDrawer ? cartDrawer.querySelector("[data-cart-subtotal]") : null;
  var cartFootEl = cartDrawer ? cartDrawer.querySelector("[data-cart-foot]") : null;

  function openCart() { if (cartDrawer) { cartDrawer.classList.add("is-open"); document.documentElement.style.overflow = "hidden"; } }
  function closeCart() { if (cartDrawer) { cartDrawer.classList.remove("is-open"); document.documentElement.style.overflow = ""; } }

  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) { e.preventDefault(); renderCart(); openCart(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (el) {
    el.addEventListener("click", closeCart);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeCart(); navDrawer && navDrawer.classList.remove("is-open"); }
  });

  function updateCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute("data-empty", cart.item_count === 0 ? "true" : "false");
    });
  }

  var assetBaseLink = document.querySelector('link[href*="theme.css"]');
  var assetBase = assetBaseLink ? assetBaseLink.href.split("theme.css")[0] : "";
  var CART_IMG = {
    "peak-running-vest": "vest-front-cut.webp",
    "peak-running-flask-500ml": "flask-single.webp",
    "peak-nasal-strips-30-pack": "strips-cut.webp",
    "peak-bundle-vest-flask": "vest-front-cut.webp",
    "double-peak-bundle-2-vest-2-flask": "vest-front-cut.webp",
    "reach-your-peak-bundle-complete-kit": "vest-front-cut.webp",
    "double-reach-your-peak-bundle": "vest-front-cut.webp",
    "gear-combo-flask-nasal-strips": "gear-duo.jpg"
  };

  /* Companion offers: what each bundle already covers, and what to pitch first */
  var OFFER_COVERS = {
    "peak-bundle-vest-flask": ["peak-running-vest", "peak-running-flask-500ml"],
    "double-peak-bundle-2-vest-2-flask": ["peak-running-vest", "peak-running-flask-500ml"],
    "reach-your-peak-bundle-complete-kit": ["peak-running-vest", "peak-running-flask-500ml", "peak-nasal-strips-30-pack"],
    "double-reach-your-peak-bundle": ["peak-running-vest", "peak-running-flask-500ml", "peak-nasal-strips-30-pack"],
    "gear-combo-flask-nasal-strips": ["peak-running-flask-500ml", "peak-nasal-strips-30-pack"]
  };
  var OFFER_ORDER = ["peak-running-flask-500ml", "peak-nasal-strips-30-pack", "peak-running-vest"];
  var FREE_DELIVERY_CENTS = 7000;

  function renderOffer(cart) {
    var box = cartDrawer && cartDrawer.querySelector("[data-cart-offer]");
    if (!box) return;
    var pool = cartDrawer.querySelectorAll("[data-offer]");
    if (!pool.length || !cart || !cart.items || !cart.items.length) {
      box.hidden = true; box.innerHTML = ""; return;
    }
    var owned = {};
    cart.items.forEach(function (it) {
      owned[it.handle] = true;
      (OFFER_COVERS[it.handle] || []).forEach(function (h) { owned[h] = true; });
    });
    var pick = null;
    for (var o = 0; o < OFFER_ORDER.length && !pick; o++) {
      if (owned[OFFER_ORDER[o]]) continue;
      for (var i = 0; i < pool.length; i++) {
        if (pool[i].getAttribute("data-handle") === OFFER_ORDER[o]) { pick = pool[i]; break; }
      }
    }
    if (!pick) { box.hidden = true; box.innerHTML = ""; return; }

    var price = parseInt(pick.getAttribute("data-price"), 10) || 0;
    var total = cart.total_price || 0;
    var unlocks = total < FREE_DELIVERY_CENTS && (total + price) >= FREE_DELIVERY_CENTS;
    var short = FREE_DELIVERY_CENTS - total;

    box.hidden = false;
    box.innerHTML =
      '<div class="cart-offer__img"><img src="' + pick.getAttribute("data-img") + '" alt=""></div>' +
      '<div class="cart-offer__body">' +
        '<span class="cart-offer__label">' +
          (unlocks ? "Add this and delivery is free" : "Goes with what you\u2019re buying") +
        "</span>" +
        '<span class="cart-offer__title">' + pick.getAttribute("data-title") + "</span>" +
        '<span class="cart-offer__benefit">' + pick.getAttribute("data-benefit") + "</span>" +
      "</div>" +
      '<div class="cart-offer__buy">' +
        '<span class="cart-offer__price">' + pick.getAttribute("data-price-label") + "</span>" +
        '<button type="button" class="cart-offer__add" data-cart-offer-add="' + pick.getAttribute("data-vid") + '">Add</button>' +
      "</div>" +
      /* full-width row so the message has space to read on one line */
      (unlocks
        ? '<span class="cart-offer__flag">You\u2019re ' + formatMoney(short) + " short \u2014 this covers it</span>"
        : "");
  }

  /* the Add button is built after page load, so it needs a delegated handler */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-cart-offer-add]") : null;
    if (!btn) return;
    var id = parseInt(btn.getAttribute("data-cart-offer-add"), 10);
    if (!id) return;
    btn.setAttribute("disabled", "disabled");
    btn.textContent = "Adding\u2026";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { renderCart(); })
      .catch(function () {
        btn.removeAttribute("disabled");
        btn.textContent = "Try again";
      });
  });

  /* Bundle thumbnails are composed from cutouts on the bundles page — mirror that here
     so the cart drawer shows the same picture instead of a lone vest. */
  var BUNDLE_TRIO = {
    "peak-bundle-vest-flask": { v: 1, f: 1, s: 0 },
    "double-peak-bundle-2-vest-2-flask": { v: 2, f: 2, s: 0 },
    "reach-your-peak-bundle-complete-kit": { v: 1, f: 1, s: 1 },
    "double-reach-your-peak-bundle": { v: 2, f: 2, s: 2 },
    "gear-combo-flask-nasal-strips": { duo: true }
  };
  function trioMarkup(handle) {
    var q = BUNDLE_TRIO[handle];
    if (!q || !assetBase) return null;
    function im(cls, file) { return '<img class="' + cls + '" src="' + assetBase + file + '" alt="" loading="lazy">'; }
    if (q.duo) return '<div class="bl__trio">' + im("bl__t-duo", "gear-duo.jpg") + "</div>";
    var h = "";
    if (q.v > 1) h += im("bl__t-vest i1", "vest-front-cut.webp");
    if (q.v > 0) h += im("bl__t-vest", "vest-front-cut.webp");
    if (q.f > 1) h += im("bl__t-flask i1", "flask-single.webp");
    if (q.f > 0) h += im("bl__t-flask", "flask-single.webp");
    if (q.s > 1) h += im("bl__t-strips i1", "strips-cut.webp");
    if (q.s > 0) h += im("bl__t-strips", "strips-cut.webp");
    return '<div class="bl__trio' + (q.v ? "" : " bl__trio--novest") + '">' + h + "</div>";
  }

  function renderCart() {
    if (!cartItemsEl) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart);
        if (cart.item_count === 0) {
          cartItemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="btn btn--ghost" href="/collections/the-collection">Shop the collection</a></div>';
          if (cartFootEl) cartFootEl.style.display = "none";
          renderOffer(cart);
          return;
        }
        if (cartFootEl) cartFootEl.style.display = "";
        var html = cart.items.map(function (item) {
          var img = (CART_IMG[item.handle] && assetBase) ? assetBase + CART_IMG[item.handle] : (item.image || "");
          var variant = item.variant_title && item.variant_title !== "Default Title" ? '<div class="cart-line__variant">' + item.variant_title + "</div>" : "";
          return (
            '<div class="cart-line" data-line-key="' + item.key + '">' +
              (trioMarkup(item.handle)
                ? '<div class="cart-line__img cart-line__img--trio">' + trioMarkup(item.handle) + "</div>"
                : '<div class="cart-line__img">' + (img ? '<img src="' + img + '" alt="">' : "") + "</div>") +
              "<div>" +
                '<div class="cart-line__title">' + item.product_title + "</div>" + variant +
                '<div class="cart-line__qty">' +
                  '<button type="button" data-qty-change="-1" aria-label="Decrease">&minus;</button>' +
                  "<span>" + item.quantity + "</span>" +
                  '<button type="button" data-qty-change="1" aria-label="Increase">+</button>' +
                "</div>" +
              "</div>" +
              '<div class="cart-line__price">' + formatMoney(item.final_line_price) +
                '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
              "</div>" +
            "</div>"
          );
        }).join("");
        cartItemsEl.innerHTML = html;
        if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.items_subtotal_price);
        renderOffer(cart);
      });
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener("click", function (e) {
      var line = e.target.closest(".cart-line");
      if (!line) return;
      var key = line.getAttribute("data-line-key");
      var qtyBtn = e.target.closest("[data-qty-change]");
      var removeBtn = e.target.closest("[data-line-remove]");
      if (!qtyBtn && !removeBtn) return;
      var newQty = 0;
      if (qtyBtn) {
        var current = parseInt(line.querySelector(".cart-line__qty span").textContent, 10);
        newQty = Math.max(0, current + parseInt(qtyBtn.getAttribute("data-qty-change"), 10));
      }
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: removeBtn ? 0 : newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { renderCart(); });
    });
  }

  /* ---------- Product form ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (wrap) {
    var dataEl = wrap.querySelector("[data-product-json]");
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var variantInput = wrap.querySelector("[data-variant-id]");
    var priceEl = wrap.querySelector("[data-price]");
    var compareEl = wrap.querySelector("[data-compare-price]");
    var atcBtn = wrap.querySelector("[data-atc]");
    var qtyInput = wrap.querySelector("[data-qty-input]");
    var stockEl = wrap.querySelector("[data-pp-stock]");
    var STOCK = {};
    var STOCK_MIN = 10;
    if (stockEl) {
      STOCK_MIN = parseInt(stockEl.getAttribute("data-threshold"), 10) || 10;
      stockEl.getAttribute("data-stock").split(",").forEach(function (pair) {
        if (!pair) return;
        var bits = pair.split(":");
        STOCK[bits[0]] = parseInt(bits[1], 10);
      });
    }

    wrap.querySelectorAll("[data-qty-adjust]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var v = Math.max(1, parseInt(qtyInput.value || "1", 10) + parseInt(btn.getAttribute("data-qty-adjust"), 10));
        qtyInput.value = v;
      });
    });

    function currentVariant() {
      var selected = [];
      wrap.querySelectorAll("[data-option-index]").forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        if (group.tagName === "SELECT") {
          selected[idx] = group.value;
        } else {
          var active = group.querySelector(".size-pill.is-active");
          selected[idx] = active ? active.getAttribute("data-value") : null;
        }
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === null || selected[i] === undefined || opt === selected[i]; });
      });
    }

    function refresh() {
      var variant = currentVariant();
      if (!variant) {
        atcBtn.setAttribute("disabled", "disabled");
        atcBtn.textContent = "Unavailable";
        return;
      }
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.style.display = "none";
        }
      }
      if (variant.available) {
        atcBtn.removeAttribute("disabled");
        atcBtn.textContent = atcBtn.getAttribute("data-label-add") || "Add to cart";
      } else {
        atcBtn.setAttribute("disabled", "disabled");
        atcBtn.textContent = "Sold out";
      }
      if (stockEl) {
        var left = STOCK[String(variant.id)];
        // only shout when the number is real, tracked, and genuinely low
        stockEl.hidden = !(variant.available && typeof left === "number" && left > 0 && left <= STOCK_MIN);
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }

    wrap.querySelectorAll(".size-pill").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var group = pill.closest("[data-option-index]");
        group.querySelectorAll(".size-pill").forEach(function (p) { p.classList.remove("is-active"); });
        pill.classList.add("is-active");
        refresh();
      });
    });
    wrap.querySelectorAll("select[data-option-index]").forEach(function (sel) {
      sel.addEventListener("change", refresh);
    });

    wrap.addEventListener("submit", function (e) {
      e.preventDefault();
      var variant = currentVariant();
      if (!variant) return;
      atcBtn.setAttribute("disabled", "disabled");
      atcBtn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variant.id, quantity: parseInt(qtyInput ? qtyInput.value : "1", 10) || 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          refresh();
          renderCart();
          openCart();
        })
        .catch(function () {
          atcBtn.removeAttribute("disabled");
          atcBtn.textContent = "Try again";
        });
    });

    refresh();
  });

  /* ---------- Quick add (single-variant buttons) ---------- */
  document.querySelectorAll("[data-quick-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = parseInt(btn.getAttribute("data-quick-add"), 10);
      btn.setAttribute("disabled", "disabled");
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          btn.removeAttribute("disabled");
          btn.textContent = btn.getAttribute("data-label") || "Add to cart";
          renderCart();
          openCart();
        })
        .catch(function () {
          btn.removeAttribute("disabled");
          btn.textContent = "Try again";
        });
    });
  });

  /* ---------- Comparison duel ---------- */
  document.querySelectorAll("[data-cx]").forEach(function (cx) {
    var panels = cx.querySelectorAll("[data-cx-panel]");
    var tabs = cx.querySelectorAll("[data-cx-go]");
    var dashes = cx.querySelectorAll("[data-cx-dash]");
    var peakViews = cx.querySelectorAll("[data-cx-peak-view]");
    var peakZoom = cx.querySelector("[data-cx-peak-zoom]");
    var theirZoom = cx.querySelector("[data-cx-their-zoom]");
    var autoMs = parseInt(cx.getAttribute("data-cx-auto"), 10) || 4000;
    var n = panels.length;
    if (!n) return;
    var current = 0;
    var timer = null;
    var pendingZoom = null;

    panels.forEach(function (p) {
      new Image().src = p.getAttribute("data-our-zoom");
      new Image().src = p.getAttribute("data-their-zoom");
    });

    function show(idx, restartTimer) {
      idx = ((idx % n) + n) % n;
      current = idx;
      var panel = panels[idx];
      panels.forEach(function (p) { p.classList.remove("is-on"); });
      panel.classList.add("is-on");
      tabs.forEach(function (t, i) {
        t.classList.toggle("is-on", i === idx);
        var prog = t.querySelector(".cx__tab-progress");
        if (prog && i === idx) {
          prog.style.animation = "none";
          void prog.offsetWidth;
          prog.style.animation = "";
        }
      });
      dashes.forEach(function (d, i) {
        d.classList.toggle("is-on", i === idx);
        d.classList.toggle("is-done", i < idx);
        var bar = d.querySelector("i");
        if (bar && i === idx) {
          bar.style.animation = "none";
          void bar.offsetWidth;
          bar.style.animation = "";
        }
      });
      var view = panel.getAttribute("data-view") || "front";
      peakViews.forEach(function (v) {
        v.classList.toggle("is-on", v.getAttribute("data-cx-peak-view") === view);
      });
      clearTimeout(pendingZoom);
      if (peakZoom) peakZoom.style.opacity = "0";
      if (theirZoom) theirZoom.style.opacity = "0";
      pendingZoom = setTimeout(function () {
        if (peakZoom) { peakZoom.src = panel.getAttribute("data-our-zoom"); peakZoom.style.opacity = "1"; }
        if (theirZoom) { theirZoom.src = panel.getAttribute("data-their-zoom"); theirZoom.style.opacity = "1"; }
      }, 260);
      if (restartTimer) restart();
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1, false); }, autoMs);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(i, true); });
      t.addEventListener("mouseenter", function () { show(i, true); });
    });

    restart();
  });

  /* ---------- Feature explorer ---------- */
  document.querySelectorAll("[data-vx]").forEach(function (vx) {
    var cards = vx.querySelectorAll("[data-vx-card]");
    var rail = vx.querySelectorAll("[data-vx-go]");
    var views = vx.querySelectorAll("[data-vx-view]");
    var dot = vx.querySelector("[data-vx-dot]");
    var dotGo = vx.querySelectorAll("[data-vx-dot-go]");
    var autoMs = parseInt(vx.getAttribute("data-vx-auto"), 10) || 5000;
    var n = cards.length;
    if (!n) return;
    var current = 0;
    var timer = null;

    function show(idx, restartTimer) {
      idx = ((idx % n) + n) % n;
      current = idx;
      var card = cards[idx];
      cards.forEach(function (c) { c.classList.remove("is-on"); });
      card.classList.add("is-on");
      rail.forEach(function (r, i) {
        r.classList.toggle("is-on", i === idx);
        var prog = r.querySelector(".vx__rail-progress");
        if (prog && i === idx) {
          prog.style.animation = "none";
          void prog.offsetWidth;
          prog.style.animation = "";
        }
      });
      dotGo.forEach(function (d, i) { d.classList.toggle("is-on", i === idx); });
      var view = card.getAttribute("data-view") || "front";
      views.forEach(function (v) {
        v.classList.toggle("is-on", v.getAttribute("data-vx-view") === view);
      });
      if (dot) {
        dot.style.left = card.getAttribute("data-x") + "%";
        dot.style.top = card.getAttribute("data-y") + "%";
      }
      if (restartTimer) restart();
    }

    function tick() { show(current + 1, false); }
    function restart() {
      clearInterval(timer);
      timer = setInterval(tick, autoMs);
    }

    rail.forEach(function (r, i) {
      r.addEventListener("click", function () { show(i, true); });
      r.addEventListener("mouseenter", function () { show(i, true); });
      r.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); show(i, true); }
      });
    });
    dotGo.forEach(function (d, i) {
      d.addEventListener("click", function () { show(i, true); });
    });
    var prev = vx.querySelector("[data-vx-prev]");
    var next = vx.querySelector("[data-vx-next]");
    if (prev) prev.addEventListener("click", function () { show(current - 1, true); });
    if (next) next.addEventListener("click", function () { show(current + 1, true); });

    restart();
  });

  /* ---------- Bundle cards: whole card taps through to the product ----------
     Mobile only - on desktop the panel is the big display area beside the kit
     picker, not a card. Guarded so a swipe on the carousel never navigates and
     so the Add button / links keep their own behaviour. */
  document.querySelectorAll("[data-bk] .bk__panel[data-bk-url]").forEach(function (panel) {
    var moved = false, sx = 0, sy = 0;
    panel.addEventListener("pointerdown", function (e) { moved = false; sx = e.clientX; sy = e.clientY; });
    panel.addEventListener("pointermove", function (e) {
      if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) moved = true;
    });
    panel.addEventListener("click", function (e) {
      if (moved) return;
      if (!window.matchMedia("(max-width: 700px)").matches) return;
      if (e.target.closest("a, button, input, select, textarea, [data-quick-add]")) return;
      var url = panel.getAttribute("data-bk-url");
      if (url) window.location.href = url;
    });
  });

  /* ---------- Flask lab (drag to collapse) ---------- */
  document.querySelectorAll("[data-fx]").forEach(function (fx) {
    var range = fx.querySelector("[data-fx-range]");
    var flask = fx.querySelector("[data-fx-flask]");
    var state = fx.querySelector("[data-fx-state]");
    if (!range || !flask) return;
    function update() {
      var t = parseInt(range.value, 10) / 100;
      range.style.setProperty("--fx-fill", (t * 100).toFixed(1) + "%");
      flask.style.transform = "scaleY(" + (1 - 0.42 * t).toFixed(3) + ") scaleX(" + (1 - 0.1 * t).toFixed(3) + ")";
      if (state) {
        state.textContent = t < 0.25 ? "Full" : t < 0.75 ? "Mid-run" : "Empty";
      }
    }
    range.addEventListener("input", update);
    update();
  });

  /* ---------- Bundle builder ---------- */
  document.querySelectorAll("[data-bk]").forEach(function (bk) {
    var rows = bk.querySelectorAll("[data-bk-row]");
    var panels = bk.querySelectorAll("[data-bk-panel]");
    if (!rows.length) return;
    rows.forEach(function (row, i) {
      row.addEventListener("click", function () {
        rows.forEach(function (r, j) {
          r.classList.toggle("is-on", j === i);
          r.setAttribute("aria-checked", j === i ? "true" : "false");
        });
        panels.forEach(function (p, j) { p.classList.toggle("is-on", j === i); });
      });
    });
    panels.forEach(function (panel) {
      var atc = panel.querySelector("[data-quick-add]");
      panel.querySelectorAll("[data-bk-size]").forEach(function (pill) {
        pill.addEventListener("click", function () {
          panel.querySelectorAll("[data-bk-size]").forEach(function (p) { p.classList.remove("is-active"); });
          pill.classList.add("is-active");
          if (atc) atc.setAttribute("data-quick-add", pill.getAttribute("data-variant-id"));
        });
      });
    });
  });

  /* ---------- Product page gallery ---------- */
  document.querySelectorAll("[data-pp]").forEach(function (pp) {
    var imgs = pp.querySelectorAll("[data-pp-img]");
    var counter = pp.querySelector("[data-pp-counter]");
    var stage = pp.querySelector("[data-pp-stage]");
    var lightbox = document.querySelector("[data-pp-lightbox]");
    var n = imgs.length;
    var current = 0;
    if (!n) return;

    function show(idx) {
      current = ((idx % n) + n) % n;
      imgs.forEach(function (im, i) { im.classList.toggle("is-on", i === current); });
      if (counter) counter.textContent = ("0" + (current + 1)).slice(-2);
    }

    var prev = pp.querySelector("[data-pp-prev]");
    var next = pp.querySelector("[data-pp-next]");
    if (prev) prev.addEventListener("click", function (e) { e.stopPropagation(); show(current - 1); });
    if (next) next.addEventListener("click", function (e) { e.stopPropagation(); show(current + 1); });

    if (stage) {
      var startX = null;
      stage.addEventListener("pointerdown", function (e) { startX = e.clientX; });
      stage.addEventListener("pointerup", function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (dx > 40) show(current - 1);
        else if (dx < -40) show(current + 1);
      });
    }

    var zoom = pp.querySelector("[data-pp-zoom]");
    if (zoom && lightbox) {
      zoom.addEventListener("click", function (e) {
        e.stopPropagation();
        lightbox.querySelector("img").src = imgs[current].src;
        lightbox.classList.add("is-open");
      });
      lightbox.addEventListener("click", function () { lightbox.classList.remove("is-open"); });
    }

    var guide = pp.querySelector("[data-pp-guide]");
    var details = pp.querySelector("[data-pp-details]");
    if (guide && details) {
      guide.addEventListener("click", function () {
        details.setAttribute("open", "");
        details.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }
  });

  /* ---------- Initial cart count ---------- */
  fetch("/cart.js").then(function (r) { return r.json(); }).then(updateCount).catch(function () {});
})();

// Live viewers (cosmetic) — jumpy two-way fluctuation like real traffic:
// mixed up/down steps of 1-4, occasional holds, soft pull back toward 6-9, range 3-18
(function () {
  var el = document.querySelector("[data-pp-live-count]");
  if (!el) return;
  var current = 7 + Math.floor(Math.random() * 2);
  var lastDir = 0;
  el.textContent = current;
  function nextValue() {
    var r = Math.random();
    var mag = r < 0.45 ? 1 : r < 0.75 ? 2 : r < 0.92 ? 3 : 4 + Math.floor(Math.random() * 4);
    var downBias = 0.5 + (current - 8) * 0.04;
    if (lastDir === 1) downBias += 0.08;
    if (lastDir === -1) downBias -= 0.08;
    var dir = Math.random() < downBias ? -1 : 1;
    var v = current + dir * mag;
    if (v < 3) v = 3 + Math.floor(Math.random() * 3);
    if (v > 18) v = 15 + Math.floor(Math.random() * 3);
    if (v === current) v += Math.random() < 0.5 ? -1 : 1;
    lastDir = v > current ? 1 : -1;
    return v;
  }
  function tick() {
    if (Math.random() < 0.72) {
      current = nextValue();
      el.classList.remove("is-tick");
      void el.offsetWidth;
      el.classList.add("is-tick");
      el.textContent = current;
    }
    setTimeout(tick, 1600 + Math.random() * 5200);
  }
  setTimeout(tick, 1800 + Math.random() * 2200);
})();


// Peak vs. the rest — product comparison explorer (3s auto-advance, never pauses)
(function () {
  var root = document.querySelector("[data-pv]");
  if (!root) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-pv-tab]"));
  var zo = Array.prototype.slice.call(root.querySelectorAll("[data-pv-zo] img"));
  var zt = Array.prototype.slice.call(root.querySelectorAll("[data-pv-zt] img"));
  var ot = root.querySelector("[data-pv-ot]"), onEl = root.querySelector("[data-pv-on]");
  var tt = root.querySelector("[data-pv-tt]"), tn = root.querySelector("[data-pv-tn]");
  var count = root.querySelector("[data-pv-count]");
  var idx = 0, n = tabs.length;
  function swap(el, text) {
    if (!el) return;
    el.textContent = text;
    el.classList.remove("is-swap"); void el.offsetWidth; el.classList.add("is-swap");
  }
  function show(i) {
    idx = (i + n) % n;
    tabs.forEach(function (t, j) {
      t.classList.toggle("is-on", j === idx);
      if (j === idx) {
        var bar = t.querySelector(".pv__timer");
        if (bar) { bar.style.animation = "none"; void bar.offsetWidth; bar.style.animation = ""; }
      }
    });
    var railEl = tabs[idx].parentElement;
    if (railEl && railEl.scrollTo) railEl.scrollTo({ left: Math.max(0, tabs[idx].offsetLeft - 30), behavior: "smooth" });
    zo.forEach(function (img, j) { img.classList.toggle("is-on", j === idx); });
    zt.forEach(function (img, j) { img.classList.toggle("is-on", j === idx); });
    var t = tabs[idx];
    swap(ot, t.getAttribute("data-ot")); swap(onEl, t.getAttribute("data-on"));
    swap(tt, t.getAttribute("data-tt")); swap(tn, t.getAttribute("data-tn"));
    if (count) count.textContent = ("0" + (idx + 1)).slice(-2);
  }
  var timer = setInterval(function () { show(idx + 1); }, 3000);
  tabs.forEach(function (t, j) {
    function pick() {
      if (j === idx) return;
      show(j);
      clearInterval(timer);
      timer = setInterval(function () { show(idx + 1); }, 3000);
    }
    t.addEventListener("mouseenter", pick);
    t.addEventListener("click", pick);
  });
  var shop = root.querySelector("[data-pv-shop]");
  if (shop) shop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
})();


// Runner testing notes — review carousel (6s auto-advance)
(function () {
  var root = document.querySelector("[data-pr]");
  if (!root) return;
  var section = root.closest(".pr") || root;
  var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-pr-tab]"));
  var photos = Array.prototype.slice.call(root.querySelectorAll("[data-pr-photo]"));
  var avatars = Array.prototype.slice.call(root.querySelectorAll("[data-pr-avatar]"));
  var quote = root.querySelector("[data-pr-quote]");
  var name = root.querySelector("[data-pr-name]");
  var meta = root.querySelector("[data-pr-meta]");
  var count = root.querySelector("[data-pr-count]");
  var author = root.querySelector(".pr__author");
  var idx = 0, n = tabs.length;
  function show(i) {
    idx = (i + n) % n;
    tabs.forEach(function (t, j) { t.classList.toggle("is-on", j === idx); });
    var tabRow = tabs[idx].parentElement;
    if (tabRow && tabRow.scrollTo) tabRow.scrollTo({ left: Math.max(0, tabs[idx].offsetLeft - 40), behavior: "smooth" });
    photos.forEach(function (img, j) { img.classList.toggle("is-on", j === idx); });
    avatars.forEach(function (img, j) { img.classList.toggle("is-on", j === idx); });
    var t = tabs[idx];
    quote.textContent = t.getAttribute("data-quote");
    name.textContent = t.getAttribute("data-name");
    meta.textContent = t.getAttribute("data-meta");
    [quote, author].forEach(function (el) { el.classList.remove("is-swap"); void el.offsetWidth; el.classList.add("is-swap"); });
    if (count) count.textContent = "0" + (idx + 1);
  }
  var timer = setInterval(function () { show(idx + 1); }, 6000);
  function reset() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, 6000); }
  tabs.forEach(function (t, j) {
    t.addEventListener("click", function () { if (j !== idx) { show(j); reset(); } });
  });
  var prev = root.querySelector("[data-pr-prev]"), next = root.querySelector("[data-pr-next]");
  if (prev) prev.addEventListener("click", function () { show(idx - 1); reset(); });
  if (next) next.addEventListener("click", function () { show(idx + 1); reset(); });
  var shop = section.parentElement ? document.querySelector("[data-pr-shop]") : null;
  shop = document.querySelector("[data-pr-shop]");
  if (shop) shop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
})();


// Bundle lab — featured carousel (4s auto, never pauses) + setup filters
(function () {
  var root = document.querySelector("[data-bl]");
  if (!root) return;
  var cards = Array.prototype.slice.call(root.querySelectorAll("[data-bl-card]"));
  var trios = Array.prototype.slice.call(root.querySelectorAll("[data-bl-ftrio]"));
  var els = {
    name: root.querySelector("[data-bl-name]"), sub: root.querySelector("[data-bl-sub]"),
    price: root.querySelector("[data-bl-price]"), compare: root.querySelector("[data-bl-compare]"),
    save: root.querySelector("[data-bl-save]"), atc: root.querySelector("[data-bl-atc]"),
    details: root.querySelector("[data-bl-details]"), count: root.querySelector("[data-bl-count]"),
    total: root.querySelector("[data-bl-total]"), bar: root.querySelector("[data-bl-bar]")
  };
  var filter = "all", list = [], pos = 0;
  function rebuild() {
    list = [];
    cards.forEach(function (c, i) { if (filter === "all" || c.getAttribute("data-cat") === filter) list.push(i); });
    if (els.total) els.total.textContent = "0" + list.length;
  }
  function show(p) {
    if (!list.length) return;
    pos = (p + list.length) % list.length;
    var fi = list[pos];
    cards.forEach(function (c, i) {
      var inFilter = filter === "all" || c.getAttribute("data-cat") === filter;
      c.classList.toggle("is-filtered", !inFilter);
      c.classList.toggle("is-featured", i === fi);
    });
    trios.forEach(function (t, i) { t.classList.toggle("is-on", i === fi); });
    var c = cards[fi];
    els.name.textContent = c.getAttribute("data-name");
    els.sub.textContent = c.getAttribute("data-sub");
    els.price.textContent = c.getAttribute("data-price");
    els.compare.textContent = c.getAttribute("data-compare");
    els.save.textContent = c.getAttribute("data-save");
    els.atc.setAttribute("data-quick-add", c.getAttribute("data-vid"));
    els.atc.innerHTML = "Add kit to bag &mdash; " + c.getAttribute("data-price") + " &rarr;";
    els.details.setAttribute("href", c.getAttribute("data-url"));
    if (els.count) els.count.textContent = "0" + (pos + 1);
    ["name", "sub", "price", "save"].forEach(function (k) {
      var el = els[k]; el.classList.remove("is-swap"); void el.offsetWidth; el.classList.add("is-swap");
    });
    if (els.bar) { els.bar.classList.remove("is-run"); void els.bar.offsetWidth; els.bar.classList.add("is-run"); }
  }
  rebuild(); show(0);
  var timer = setInterval(function () { show(pos + 1); }, 4000);
  function reset() { clearInterval(timer); timer = setInterval(function () { show(pos + 1); }, 4000); }
  var prev = root.querySelector("[data-bl-prev]"), next = root.querySelector("[data-bl-next]");
  if (prev) prev.addEventListener("click", function () { show(pos - 1); reset(); });
  if (next) next.addEventListener("click", function () { show(pos + 1); reset(); });
  root.querySelectorAll("[data-bl-filter]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      filter = btn.getAttribute("data-bl-filter");
      root.querySelectorAll("[data-bl-filter]").forEach(function (b) { b.classList.toggle("is-on", b === btn); });
      rebuild(); show(0); reset();
    });
  });
})();


// Cart goal bar — progress toward the ONE reward Shopify actually grants:
// free Standard delivery, which the store's shipping rule applies from $60.
(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll("[data-goal]"));
  if (!roots.length) return;
  var GOAL = 60;
  function fmt(n) { var s = (Math.round(n * 100) / 100).toFixed(2); if (s.slice(-3) === ".00") s = s.slice(0, -3); return "$" + s; }
  function render(total) {
    var pct = Math.min(total / GOAL * 100, 100);
    roots.forEach(function (root) {
      var fill = root.querySelector("[data-goal-fill]");
      var msg = root.querySelector("[data-goal-msg]");
      if (fill) fill.style.width = pct + "%";
      root.querySelectorAll("[data-goal-dot]").forEach(function (d) {
        d.classList.toggle("is-hit", total >= parseFloat(d.getAttribute("data-goal-dot")));
      });
      if (!msg) return;
      if (total <= 0) msg.innerHTML = "Add <b>" + fmt(GOAL) + "</b> of gear to unlock <b>FREE DELIVERY</b>";
      else if (total < GOAL) msg.innerHTML = "<b>" + fmt(GOAL - total) + "</b> more to unlock <b>FREE DELIVERY</b>";
      else msg.innerHTML = "<b>FREE DELIVERY</b> unlocked";
    });
  }
  function refresh() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      render(c.total_price / 100);
    }).catch(function () {});
  }
  refresh();
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-atc], [data-quick-add], [data-bl-atc], .pp__up-add, .product-card__atc, .cart-drawer button, [data-cart-drawer] button, [data-cart-open]")) {
      setTimeout(refresh, 1200);
      setTimeout(refresh, 2800);
    }
  });
})();


// Story page — scroll step counter (01 / 04)
(function () {
  var root = document.querySelector("[data-st]");
  if (!root) return;
  var steps = Array.prototype.slice.call(root.querySelectorAll("[data-st-step]"));
  var count = root.querySelector("[data-st-count]");
  if (!steps.length || !count) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) count.textContent = "0" + (steps.indexOf(en.target) + 1);
    });
  }, { threshold: 0.45 });
  steps.forEach(function (s) { obs.observe(s); });
})();


// Review popper — cosmetic toast, first at ~3.5s then every 10s, 10 reviews looping
(function () {
  var root = document.querySelector("[data-rp]");
  var dataEl = document.querySelector("[data-rp-data]");
  if (!root || !dataEl) return;
  var reviews;
  try { reviews = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!reviews || !reviews.length) return;
  var text = root.querySelector("[data-rp-text]");
  var name = root.querySelector("[data-rp-name]");
  var avatar = root.querySelector("[data-rp-avatar]");
  var i = 0, hideTimer;
  function showOne() {
    var r = reviews[i % reviews.length];
    i++;
    text.textContent = "\u201C" + r.q + "\u201D";
    name.textContent = "\u2014 " + r.n;
    avatar.textContent = r.n.charAt(0);
    root.classList.add("is-on");
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { root.classList.remove("is-on"); }, 7000);
  }
  root.querySelector("[data-rp-close]").addEventListener("click", function () {
    root.classList.remove("is-on");
    clearTimeout(hideTimer);
  });
  setTimeout(function () {
    showOne();
    setInterval(showOne, 10000);
  }, 3500);
})();


// Smart header — hides on scroll down, reveals on scroll up; mountain marks the active page
(function () {
  var header = document.querySelector(".site-header");
  if (!header) return;
  var lastY = window.scrollY, ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      if (y > lastY + 4 && y > 150) header.classList.add("is-hidden");
      else if (y < lastY - 4) header.classList.remove("is-hidden");
      lastY = y;
      ticking = false;
    });
  }, { passive: true });

  var peak = header.querySelector("[data-nav-peak]");
  if (!peak) return;
  var inner = header.querySelector(".site-header__inner");
  var links = Array.prototype.slice.call(header.querySelectorAll(".site-header__nav a"));
  if (!links.length) return;
  function norm(p) { return (p || "/").replace(/\/$/, "") || "/"; }
  function activeLink() {
    var path = norm(location.pathname);
    var best = null, bestLen = -1;
    links.forEach(function (a) {
      var p = norm(a.pathname);
      var hit = p === "/" ? path === "/" : (path === p || path.indexOf(p + "/") === 0);
      if (hit && p.length > bestLen) { best = a; bestLen = p.length; }
    });
    return best;
  }
  function moveTo(a, instant) {
    if (!a) { peak.classList.remove("is-on"); return; }
    var r = a.getBoundingClientRect();
    if (r.width < 5) { peak.classList.remove("is-on"); return; }
    var hr = inner.getBoundingClientRect();
    var left = r.left - hr.left + r.width / 2 - 15;
    if (instant) { peak.style.transition = "none"; }
    peak.style.left = left + "px";
    if (instant) { void peak.offsetWidth; peak.style.transition = ""; }
    else {
      peak.classList.add("is-moving");
      clearTimeout(peak._t);
      peak._t = setTimeout(function () { peak.classList.remove("is-moving"); }, 460);
    }
    peak.classList.add("is-on");
  }
  moveTo(activeLink(), true);
  links.forEach(function (a) {
    a.addEventListener("mouseenter", function () { moveTo(a); });
  });
  inner.addEventListener("mouseleave", function () { moveTo(activeLink()); });
  window.addEventListener("resize", function () { moveTo(activeLink(), true); });
})();


// Product-card add-to-cart: block the card link navigation, let quick-add handle the click
document.addEventListener("click", function (e) {
  if (e.target.closest(".product-card__atc")) e.preventDefault();
});


// Close product lightbox with Escape (the X and backdrop clicks already close it)
(function () {
  var lb = document.querySelector("[data-pp-lightbox]");
  if (!lb) return;
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") lb.classList.remove("is-open");
  });
})();


// Promo timer — vest card on every page, pops 5s after entry, stays until X (once per 24h)
(function () {
  var DUR = 15 * 60 * 1000, DAY = 24 * 3600 * 1000;
  try {
    var claimedW = +localStorage.getItem("pg_t_claim") || 0;
    if (claimedW && Date.now() - claimedW > DUR && !localStorage.getItem("pg_t_expired")) {
      fetch("/discount/PEAK5-EXPIRED").catch(function () {});
      localStorage.setItem("pg_t_expired", "1");
    }
  } catch (e) {}
  try { if (+localStorage.getItem("pg_t_claim") > 0) return; } catch (e) {}
  try { if (sessionStorage.getItem("pg_t_closed")) return; } catch (e) {}
  var start = 0;
  try { start = +localStorage.getItem("pg_t_start") || 0; } catch (e) {}
  var now = Date.now();
  if (!start || now - start > DAY) {
    start = now;
    try {
      localStorage.setItem("pg_t_start", String(start));
      localStorage.removeItem("pg_t_claim");
      localStorage.removeItem("pg_t_expired");
    } catch (e) {}
  }
  if (now - start >= DUR) return;
  var link = document.querySelector('link[href*="theme.css"]');
  var base = link ? link.href.split("theme.css")[0] : "";
  setTimeout(function () {
    var el = document.createElement("div");
    el.className = "pt";
    el.innerHTML = '<button type="button" class="pt__close" data-pt-close aria-label="Dismiss offer">&times;</button>' +
      '<a class="pt__vest" data-pt-shop href="/discount/PEAK5?redirect=/products/peak-running-vest" aria-label="Shop the vest with 5% extra off">' +
      '<img src="' + base + 'vest-front-cut.webp" alt="" aria-hidden="true">' +
      '<span class="pt__overlay"><span class="pt__label">Order within</span><b class="pt__time" data-pt-time></b><span class="pt__off">5% extra off</span></span>' +
      '</a>';
    document.body.appendChild(el);
    el.querySelector("[data-pt-close]").addEventListener("click", function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      el.parentNode && el.parentNode.removeChild(el);
      clearInterval(iv);
      try { sessionStorage.setItem("pg_t_closed", "1"); } catch (e2) {}
    });
    el.querySelector("[data-pt-shop]").addEventListener("click", function () {
      try { localStorage.setItem("pg_t_claim", String(Date.now())); localStorage.removeItem("pg_t_expired"); } catch (e2) {}
    });
    var timeEl = el.querySelector("[data-pt-time]");
    function tick() {
      var left = DUR - (Date.now() - start);
      if (left <= 0) { el.parentNode && el.parentNode.removeChild(el); clearInterval(iv); return; }
      var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
      timeEl.textContent = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
    }
    var iv = setInterval(tick, 1000);
    tick();
  }, 5000);
})();


// Claim countdown — vest-styled sticky warning while the claimed 5% offer is live
(function () {
  var DUR = 15 * 60 * 1000;
  var claimed = 0;
  try { claimed = +localStorage.getItem("pg_t_claim") || 0; } catch (e) {}
  if (!claimed || Date.now() - claimed >= DUR) return;
  try { if (sessionStorage.getItem("pg_ct_closed")) return; } catch (e) {}
  var link = document.querySelector('link[href*="theme.css"]');
  var base = link ? link.href.split("theme.css")[0] : "";
  var el = document.createElement("div");
  el.className = "ct";
  el.innerHTML = '<span class="ct__vest">' +
    '<button type="button" class="ct__close" aria-label="Dismiss">&times;</button>' +
    '<img src="' + base + 'vest-front-cut.webp" alt="" aria-hidden="true">' +
    '<span class="ct__overlay"><span class="ct__label">Checkout within</span><b class="ct__time" data-ct-time></b><span class="ct__note">to keep 5% off</span></span>' +
    '</span>';
  document.body.appendChild(el);
  el.querySelector(".ct__close").addEventListener("click", function () {
    el.parentNode && el.parentNode.removeChild(el);
    try { sessionStorage.setItem("pg_ct_closed", "1"); } catch (e2) {}
  });
  var t = el.querySelector("[data-ct-time]");
  function tick() {
    var left = DUR - (Date.now() - claimed);
    if (left <= 0) { el.parentNode && el.parentNode.removeChild(el); clearInterval(iv); return; }
    var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
    t.textContent = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
  }
  var iv = setInterval(tick, 1000);
  tick();
})();


/* ---------- FAQ smooth expand / collapse ---------- */
(function () {
  function initFaq() {
    document.querySelectorAll(".faq details").forEach(function (d) {
      var sum = d.querySelector("summary");
      var body = d.querySelector(".faq__a");
      if (!sum || !body) return;
      var busy = false;
      sum.addEventListener("click", function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        var done = function () {
          body.removeEventListener("transitionend", done);
          body.style.height = "";
          busy = false;
        };
        if (d.open) {
          body.style.height = body.scrollHeight + "px";
          requestAnimationFrame(function () {
            body.addEventListener("transitionend", function close() {
              body.removeEventListener("transitionend", close);
              d.open = false;
              body.style.height = "";
              busy = false;
            });
            body.style.height = "0px";
          });
        } else {
          d.open = true;
          body.style.height = "0px";
          requestAnimationFrame(function () {
            body.addEventListener("transitionend", done);
            body.style.height = body.scrollHeight + "px";
          });
        }
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initFaq);
  else initFaq();
})();
